import { Button, Input, Popup, Toast } from "antd-mobile";
import { LeftOutline } from "antd-mobile-icons";
import "./index.scss";
import { useEffect, useState } from "react";
import { getEmailCode, loginEmail } from "./api";

// 邮箱正则
const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const LoginEmail = (props: any) => {
  const { visible, setVisible } = props;
  const [getCode, setGetCode] = useState(false);
  const [time, setTime] = useState(60);
  const [disabled, setDisabled] = useState(true);
  const [formValue, setFormValue] = useState({ email: "", code: "" });
  useEffect(() => {
    if (time > 0 && time < 60) {
      setTimeout(() => {
        setTime(time - 1);
      }, 1000);
    } else {
      setGetCode(false);
    }
  }, [time]);
  // 数据变更
  const handleChange = (key: string, value: any) => {
    if (key === "email") {
      setDisabled(!emailReg.test(value));
    }
    let formValue_ = { ...formValue } as any;
    formValue_[key] = value;
    setFormValue(formValue_);
  };
  // 获取验证码
  const getEmailCodeApi = () => {
    getEmailCode(formValue.email).then(res => {
      if (res.code !== 0) {
        Toast.show({
          icon: 'fail',
          content: res.msg || '验证码发送失败！',
        })
      }
    })
  }
  // 邮箱登录
  const loginEmailApi = () => {
    if (formValue.email === '') {
      Toast.show('请输入邮箱账号')
      return
    }
    if (disabled) {
      Toast.show('请输入正确的邮箱账号')
      return
    }
    if (formValue.code === '') {
      Toast.show('请输入验证码')
      return
    }
    loginEmail(formValue).then(res => {
      if (res.code) {
        Toast.show({
          icon: 'fail',
          content: res.msg || '异常',
        })
      }else{
        window.location.href = '/#/home'
      }
    })
  }
  return (
    <Popup
      visible={visible}
      position="right"
      onMaskClick={() => {
        setVisible(false);
      }}
      onClose={() => {
        setVisible(false);
      }}
      bodyStyle={{ height: "100vh", width: "100vw" }}
    >
      <div className="loginEmail">
        <div className="loginEmail-return">
          <span onClick={() => setVisible(false)}>
            <LeftOutline />
          </span>
        </div>
        <div className="loginEmail-tip">
          <div>邮箱登录</div>
        </div>
        <div className="loginEmail-form">
          <div className="loginEmail-form-passName">
            <Input
              style={{ "--color": "black" }}
              placeholder="请输入邮箱"
              value={formValue.email}
              onChange={(val) => handleChange("email", val)}
            />
          </div>
          <div className="loginEmail-form-passWord">
            <Input
              style={{ "--color": "black" }}
              placeholder="请输入邮箱验证码"
              clearable
              value={formValue.code}
              onChange={(val) => handleChange("code", val)}
            />
            <div
              style={{
                fontSize: "1.6rem",
                width: "16rem",
                color: disabled ? "rgb(203 202 202)" : "",
              }}
            >
              {!getCode ? (
                <span
                  onClick={() => {
                    if (disabled) return;
                    getEmailCodeApi()
                    setGetCode(true);
                    setTime(59);
                  }}
                >
                  获取验证码
                </span>
              ) : (
                <span style={{ color: "black" }}>{time}s后重新获取</span>
              )}
            </div>
          </div>
        </div>
        <div className="loginEmail-btn">
          <Button onClick={loginEmailApi} style={{ height: "5rem" }} block>
            登录
          </Button>
        </div>
      </div>
    </Popup>
  );
};
export default LoginEmail;
